import { useState } from "react";
import { Modal } from "react-bootstrap";
import styles from "../components/MapCategory/MapCategory.module.scss";
import { toast } from "react-toastify";
import { getApiUrl } from "@utils/baseUrl";
import axios from "axios";

const CRM_OPTIONS = {
  SALESFORCE: "Salesforce",
  HUBSPOT: "Hubspot",
  ZOHO: "Zoho",
  OTHER: "Other CRM",
};

const ExportCrmModal = ({ show, handleClose, activeTab }) => {
  const [selectedCrm, setSelectedCrm] = useState("");
  const [otherCrmDetails, setOtherCrmDetails] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCrmChange = (value) => {
    setSelectedCrm(value);
    if (value !== CRM_OPTIONS.OTHER) {
      setOtherCrmDetails("");
    }
  };

  const isSubmitDisabled = () => {
    if (!selectedCrm) return true;
    if (selectedCrm === CRM_OPTIONS.OTHER && !otherCrmDetails.trim()) return true;
    return isSubmitting;
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const payload = {
        crm_details: selectedCrm === CRM_OPTIONS.OTHER ? otherCrmDetails : selectedCrm.toLowerCase(),
        tabCategory: `${activeTab} Tab`,
      };
      await axios.post(getApiUrl("userCrmData"), payload);
      toast.success("Thanks for showing your interest in the CRM. Your customer success manager will reach out to you at the earliest to discuss more in detail");
      handleClose();
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Modal
        centered
        show={show}
        backdrop="static"
        onHide={() => {
          handleClose();
        }}>
        <Modal.Header className="tw-p-[0.5rem]">
          <Modal.Title>Export to CRM</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="tw-font-bold">
            Your account is not connected to any supported CRMs<span className="tw-text-red-500">*</span>
          </p>
          <p className="tw-mt-4">Streamline your workflow by connecting the CRM your team uses</p>
          <div className="tw-gap-1">
            {Object.values(CRM_OPTIONS).map((crm) => (
              <div key={crm} className={styles.category}>
                <input type="radio" id={crm} name="crm" value={crm} checked={selectedCrm === crm} onChange={(e) => handleCrmChange(e.target.value)} className={styles.radioButton} />
                <label htmlFor={crm}>{crm}</label>
              </div>
            ))}
          </div>
          {selectedCrm === CRM_OPTIONS.OTHER && (
            <div className="tw-mt-4 tw-mx-4">
              <input type="text" placeholder="Enter CRM details here" value={otherCrmDetails} onChange={(e) => setOtherCrmDetails(e.target.value)} className="form-control search-input" />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="tw-mr-3">
          <button className="fav-modal-cancel !tw-rounded-[8px]" onClick={handleClose}>
            Cancel
          </button>
          <button className="btn btn-primary !tw-rounded-[8px] trademo-new-btn disabled:tw-bg-primary-purple-500 tw-border-none" onClick={handleSubmit} disabled={isSubmitDisabled()}>
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ExportCrmModal;
